<app-bottom-sheet #sheet ariaLabel="نتیجه واریز وجه" bodyClass="-mx-4" footerClass="pt-2 pb-4" (closed)="onClosed()">
	<ng-template #body>
		<div
			class="flex flex-col items-center gap-3 px-4 py-3 text-center"
			dir="rtl"
			aria-labelledby="deposit-payment-result-title">
			<span
				class="flex h-12 w-12 items-center justify-center rounded-xl"
				[class.bg-green-050]="result().success"
				[class.text-green-500]="result().success"
				[class.bg-red-050]="!result().success"
				[class.text-red-500]="!result().success">
				<ui-icon
					width="24"
					height="24"
					aria-hidden="true"
					[iconName]="result().success ? 'transaction-check' : 'transaction-error'" />
			</span>

			<h1 id="deposit-payment-result-title" class="text-sm font-bold text-gray-900">
				{{ result().success ? 'واریز موفق' : result().canceled ? 'انصراف از واریز' : 'واریز ناموفق' }}
			</h1>

			@if (!result().canceled) {
				<p class="max-w-80 font-normal text-3.25 leading-5 text-gray-700">
					@if (result().success) {
						واریز وجه با موفقیت انجام شد.
					} @else {
						<span>
							در صورت کسر وجه از حساب شما،
							<br />
							مبلغ حداکثر تا ۷۲ ساعت عودت داده خواهد شد.
							<br />
							در غیر این صورت، با پشتیبانی مفید (۰۲۱۸۷۰۰) تماس بگیرید.
						</span>
					}
				</p>
			}
		</div>
	</ng-template>

	<ng-template #footer>
		<ui-button
			class="w-full"
			extraButtonClasses="w-full"
			variant="mute"
			size="lg"
			data-cy="deposit-payment-result-close"
			(clicked)="onClose()">
			بستن
		</ui-button>
	</ng-template>
</app-bottom-sheet>
